
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { UnitType } from "@/types/unit";

@Component
export default class UnitDropdown extends Vue {
  @Prop({ default: null })
  unitTypes!: UnitType[];
}
